module.exports = __webpack_public_path__ + "static/media/bg_img_3.10213859.jpg";